"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var WorkerMiniZinc_1 = tslib_1.__importDefault(require("./internal/WorkerMiniZinc"));
var minizinc_js_1 = tslib_1.__importDefault(require("minizinc-js"));
var gecode_js_1 = tslib_1.__importDefault(require("gecode-js"));
function createSolver(module, moduleName) {
    return {
        info: module,
        create: function () { return module.createWorkerClient(new Worker(moduleName)); }
    };
}
var WebWorkerMiniZinc = /** @class */ (function (_super) {
    tslib_1.__extends(WebWorkerMiniZinc, _super);
    function WebWorkerMiniZinc(options) {
        return _super.call(this, {
            mzn: typeof options.mzn === 'function' ? options.mzn : function () { return minizinc_js_1.default.createWorkerClient(new Worker(options.mzn || 'minizinc.worker.js')); },
            solvers: options.solvers && options.solvers.length > 0 ? options.solvers : [
                createSolver(gecode_js_1.default, 'gecode.worker.js')
            ],
            extraIncludeFiles: options.extraIncludeFiles
        }) || this;
    }
    return WebWorkerMiniZinc;
}(WorkerMiniZinc_1.default));
exports.default = WebWorkerMiniZinc;
//# sourceMappingURL=WebWorkerMiniZinc.js.map